import {
    cleanCommonParams,
    mapAttachmentsParams,
    mapTagsParams,
    mapContentParams,
    mapFeedItemParams,
    mapImageParams,
    mapPlatformsParams,
    mapProductsParams,
    mapSalesChannelsParams,
    mapStatesParams,
} from './common';

const mapFieldManagementNewsParams = (
    isCreate,
    {
        attachments,
        tags,
        categories,
        content,
        feed_item,
        image,
        platforms,
        products,
        sales_channels,
        search_phrase_ids,
        states,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            field_management_news: {
                ...cleanCommonParams(params),
                ...mapAttachmentsParams(isCreate, attachments),
                ...mapTagsParams(isCreate, tags),
                ...mapContentParams(isCreate, content),
                ...mapFeedItemParams(isCreate, feed_item),
                ...mapImageParams(isCreate, image),
                ...mapPlatformsParams(isCreate, platforms),
                ...mapProductsParams(isCreate, products),
                ...mapSalesChannelsParams(isCreate, sales_channels),
                ...mapStatesParams(isCreate, states),
                category_ids: categories,
                search_phrase_ids: search_phrase_ids || [],
            },
        });
    });
};

export { mapFieldManagementNewsParams };
